import getStateVisuals from './stateVisuals';
import NodeHandles from './NodeHandles';

const JunctionNode = ({
    data,
}) => {
    const visuals = getStateVisuals(data.state);

    return (
        <>
            <NodeHandles />

            <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-white"
                style={{ height: 18, width: 18 }}
            >
                <i className={`${visuals.icon} text-${visuals.color} font-size-14`} />
            </div>
        </>
    );
};

export default JunctionNode;
